"use strict";
// Grid-row-gap property parser (LEGACY ALIAS)
// This property has been deprecated in favor of row-gap
// https://developer.mozilla.org/en-US/docs/Web/CSS/row-gap
// https://www.w3.org/TR/css-align-3/#gap-legacy
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
exports.toCSSValue = toCSSValue;
const row_gap_1 = require('./row-gap.cjs');
/**
 * Parse a CSS grid-row-gap property string (legacy alias for row-gap)
 * @deprecated Use row-gap instead
 */
function parse(value) {
    return (0, row_gap_1.parse)(value);
}
/**
 * Convert a parsed grid-row-gap back to CSS string (legacy alias for row-gap)
 * @deprecated Use row-gap instead
 */
function toCSSValue(parsed) {
    return (0, row_gap_1.toCSSValue)(parsed);
}
